import React,{Component} from 'react';
import './Footer.css';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

// import androidImage from '../../theme/android.png';
import {  appAdress, appPhone, appEmail } from '../../_utils/config';
import Message from '@acri-tools/react-tools/components/Message/Message';

import { sendEmail } from '@acri-tools/react-tools/utils/contact';

interface MyProps{
    login?:any
}

class Footer extends Component<MyProps,{}>{
    state={
        from:'',
        subject:'',
        message:'',

        emailMessage:'',
        emailMessageType:'warn',
    }
    componentDidMount(){
        if(this.props.login.user){
            this.setState({
                from:this.props.login.user.email
            })
        }
    }
    render(){
        return (
            !isMobile &&
            <div id="footer">
                <div className="main-footer">

                    <div className="footer-container">
                        <div className="footer-title">S3PS Platform</div>
                        <div className="footer-description">
                        The Sentinel-3A (S3A) Production service is a central component of the Copernicus Space Component
                        (CSC) operations. Its primary role is to generate products from the Sentinel-3A satellite
                        measurements.
                        <br/>
                        <br/>
                        The aim of the S3A systematic production service is to process data acquired by the
                        Sentinel satellites and deliver the generated data on time (timeliness is defined in the SLA).
                        </div>
                    </div>


                    <div className="footer-container">
                        <div className="footer-title">Email us</div>
                        <div className="form">
                            <div className="form-field">
                                <label>
                                    <i  className="fas fa-envelope" />
                                    Email
                                </label>
                                <input type="text" value={this.state.from} onChange={(e)=>{this.setState({emailMessage:'', from:e.target.value})}}/>
                            </div>
                            <div className="form-field">
                                <label>
                                    <i  className="fas fa-pen" />
                                    Subject
                                </label>
                                <input type="text" value={this.state.subject} onChange={(e)=>{this.setState({emailMessage:'', subject:e.target.value})}}/>
                            </div>
                            <div className="form-field">
                                <label>
                                    <i  className="fas fa-align-left" />
                                    Message
                                </label>
                                <textarea value={this.state.message} onChange={(e)=>{this.setState({emailMessage:'', message:e.target.value})}}/>
                            </div>

                            <Message message={ this.state.emailMessage } type={ this.state.emailMessageType }/>
                            
                            <div
                                className="custom-button send"
                                onClick={()=>{
                                    sendEmail(
                                        this.state.from,this.state.subject,this.state.message,
                                        ()=>{ this.setState({
                                            message:'', subject:'', emailMessage:'Successfully sent email', emailMessageType:'success'
                                        }) }, // ON SUCCESS
                                        (emailMessage:string, emailMessageType:string)=>{ this.setState({emailMessage, emailMessageType}) }, // ERROR CALLBACK
                                    )
                                }}
                            >
                                <i className="far fa-paper-plane"/> Send
                            </div>
                        </div>
                    </div>


                    <div className="footer-container">
                        <div className="footer-title">Contact information</div>
                        <div id="contact-info">
                            <div className="info">
                                <div className="info-title">
                                    <i className="fas fa-envelope"/>
                                    Email
                                </div>
                                <div className="value"><a href={`mailto:${appEmail}`}>{appEmail}</a></div>
                            </div>
                            <div className="info">
                                <div className="info-title">
                                    <i className="fas fa-map-marker-alt"/>
                                    Location
                                </div>
                                <div className="value">{appAdress}</div>
                            </div>
                            <div className="info">
                                <div className="info-title">
                                    <i className="fas fa-phone-alt"/>
                                    Phone
                                </div>
                                <div className="value"><a href={`tel:${appPhone}`}>{appPhone}</a></div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="sub-footer">
                    <div className="rights">
                        <div className="rights-text">
                            © ACRI-ST 2021. All Rights Reserved.
                        </div>
                        <div className="rights-links">
                            {/* <a href="" target="_blank">Privacy Policy</a>
                            <i className="bullet fas fa-circle"/>
                            <a href="" target="_blank">GRPD</a>
                            <i className="bullet fas fa-circle"/>
                            <a href="" target="_blank">Terms & Conditions</a> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state:any) =>{
    return {
        login: state.login
    }
}

export default connect(mapStateToProps)(Footer);
